import type { ContainerProps } from '@adobe/aem-react-editable-components';

const config = {
	emptyLabel: 'ExperienceFragment',
	isEmpty: (props: ContainerProps & { configured?: boolean }) =>
		!props || !props.configured,
};

export default config;
